<div class="left_navigation_update">

  <!-- My Account Update Profile -->
  <div class="updatepro_left--slider">

    <div class="updatepro_left--container">
      <div class="updatepro_left--content">

        <div class="updatepro_left--content_heading myacc-pages-hdng">
          <h2 class="heading"><p>{{'updateprofileComp.updatedetails' | translate}}</p>
            <span class="back-icn" (click)="goBack()"> 
              <small class="show-desk">✕</small>
              <i class="icon icon-arrow-2 show-mobile"></i>
            </span>
          </h2>
        </div>

        <div class="update_profile_block">
          <div class="container-fluid">
            <form [formGroup]="updateprofile">
              
              <div class="row">
                <div class="custom_padding col-xs-12 col-sm-6 col-md-6 left_signup-12">
                  <div class="form-group" [ngClass]="getFormFiledClass('firstName',updateprofile, isSubmitted)">
                    <div class="controls">
                      <input type="text" formControlName="firstName" name="firstName" id="firstName"
                        class="floatLabel form-control" (focus)="onFocusForElement('firstName')"
                        (focusout)="onFocusOutForElement()" [readonly]="isReadOnlyAttribute()" />
                      <label for="firstName">{{'updateprofileComp.updateprofile2' | translate}}</label>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('firstName',updateprofile) && (updateprofile.controls['firstName'].value || isSubmitted)">
                      {{getErrorMessage('firstName',updateprofile)}}</div>
                  </div>
                </div>

                <!-- last name -->

                <div class="custom_padding col-xs-12 col-sm-6 col-md-6 left_signup-12">
                  <div class="form-group" [ngClass]="getFormFiledClass('lastName',updateprofile, isSubmitted)">
                    <div class="controls">
                      <input type="text" formControlName="lastName" name="lastName" id="lastName"
                        class="floatLabel form-control" (focus)="onFocusForElement('lastName')"
                        (focusout)="onFocusOutForElement()" [readonly]="isReadOnlyAttribute()" />
                      <label for="lastName">{{'updateprofileComp.updateprofile3' | translate}}</label>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('lastName',updateprofile) && (updateprofile.controls['lastName'].value || isSubmitted)">
                      {{getErrorMessage('lastName',updateprofile)}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- Street address -->

                <div class="custom_padding col-xs-12 col-sm-12 col-md-12">
                  <div class="form-group" [ngClass]="getFormFiledClass('address1',updateprofile, isSubmitted)">
                    <div class="controls">
                      <input type="text" formControlName="address1" name="address1" class="floatLabel form-control"
                        id="address1" (focus)="onFocusForElement('address1')" (focusout)="onFocusOutForElement()"
                        [readonly]="isReadOnlyAttribute()" />
                      <label for="address1">{{'updateprofileComp.updateprofile4' | translate}}</label>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('address1',updateprofile) && (updateprofile.controls['address1'].value || isSubmitted)">
                      {{getErrorMessage('address1',updateprofile)}}</div>
                  </div>
                </div>
              </div>

              <div class="row no-margin">
                <div class="custom_padding col-xs-6 col-sm-6 col-md-6 left_signup-12">
                  <!-- city -->
                  <div class="form-group" [ngClass]="getFormFiledClass('city',updateprofile, isSubmitted)">
                    <div class="controls">
                      <input type="text" formControlName="city" name="city" class="floatLabel form-control" id="city"
                        (focus)="onFocusForElement('city')" (focusout)="onFocusOutForElement()"
                        [readonly]="isReadOnlyAttribute()" />
                      <label for="city">{{'updateprofileComp.updateprofile5' | translate}}</label>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('city',updateprofile) && (updateprofile.controls['city'].value || isSubmitted)">
                      {{getErrorMessage('city',updateprofile)}}</div>
                  </div>
                </div>
                <div class="custom_padding col-xs-6 col-sm-6 col-md-6 left_signup-12">
                  <!-- zip -->
                  <div class="form-group" [ngClass]="getFormFiledClass('zipCode',updateprofile, isSubmitted)">
                    <div class="controls">
                      <input type="text" formControlName="zipCode" id="zip" class="floatLabel form-control"
                        (focus)="onFocusForElement('zipCode')" (focusout)="onFocusOutForElement()"
                        [readonly]="isReadOnlyAttribute()" />
                      <label for="zip">{{'updateprofileComp.updateprofile6' | translate}}</label>
                    </div>
                    <div class="arrow_box_small" *ngIf="shouldShowErrors('zipCode',updateprofile) && (updateprofile.controls['zipCode'].value || isSubmitted)">
                      {{getErrorMessage('zipCode',updateprofile)}}</div>
                  </div>
                </div>
              </div>

              <!-- country -->
              <div class="row no-margin country-div">
                <div class="custom_padding col-sm-12">
                  <div class="form-group" [ngClass]="getFormFiledClass('countryCode',updateprofile, isSubmitted)">
                    <div class="controls select-succ">
                      <select formControlName="countryCode" [attr.name]="ipCountry == 'SE' ? null : 'country'" [attr.autocomplete]="ipCountry == 'SE' ? 'new-password' : 'on'" id="country" (focus)="onFocusForElement('countryCode')"
                        (focusout)="onFocusOutForElement()" class="floatLabel form-control classic"
                        [ngClass]="isReadOnlyAttribute() ? 'disabled' : '' " (change)="onCountrySelect()">
                        <!-- <option selected="country">Country</option> -->
                        <option selected value="" disabled>{{'updateprofileComp.updateprofile7' | translate}}</option>
                        <option *ngFor="let country of availableCountries" [ngValue]="country.iso">{{country.name}}
                        </option>
                      </select>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('countryCode',updateprofile)">
                      {{getErrorMessage('countryCode',updateprofile)}} </div>
                  </div>
                </div>
              </div>
              <!-- state -->
              <div class="row no-margin" *ngIf="isSelectedCountryStateDataAvailable">
                <div class="custom_padding col-sm-12">
                  <div class="form-group" [ngClass]="getFormFiledClass('state',updateprofile, isSubmitted)">
                    <div class="controls select-succ">
                      <select formControlName="state" id="state" (focus)="onFocusForElement('state')"
                        (focusout)="onFocusOutForElement()" class="floatLabel form-control classic"
                        [ngClass]="isReadOnlyAttribute() ? 'disabled' : '' ">
                        <option selected value="" disabled>{{'registrationStepTwo.state' | translate}}</option>
                        <option *ngFor="let state of availableStates" [ngValue]="state.code">{{state.name}}
                        </option>
                      </select>
                    </div>
                    <div class="arrow_box" *ngIf="shouldShowErrors('state',updateprofile)">
                      {{getErrorMessage('state',updateprofile)}} </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="custom_padding col-xs-12 col-sm-12 col-md-12"
                  [ngClass]="isReadOnlyAttribute() ? 'disabled' : '' ">
                  <!-- phno -->
                  <div class="form-group" [ngClass]="getFormFiledClass('phoneNumber',updateprofile, isSubmitted)">
                    <div class="tel-number controls" id="phoneNumberFlag">
                      <input class="coutry-code form-control floatLabel inputWithoutDecimal" type="tel" id="phone-number-feild"
                        formControlName="phoneNumber" name="phoneNumber" (blur)="checkmobilereg('',false)"
                        (focus)="onFocusForElement('phoneNumber')" (focusout)="onFocusOutForElement()"
                        [readonly]="isReadOnlyAttribute()">
                      <label for="phoneNumberFlag"
                        [ngStyle]="{ 'opacity': (ipCurrCountry === 'SE' && !toggleSwedenLable) ? '0.5' : ''}"
                        class="phone">{{ipCurrCountry == 'SE' && !toggleSwedenLable ? '731234567' : ('updateprofileComp.updateprofile8' | translate)}}</label>
                        <!-- <label *ngIf="ipCurrCountry == 'SE'" for="phoneNumberFlag" class="phone">731234567</label> -->
                    </div>
                    <div class="arrow_box_small" *ngIf="getFormFiledClass('phoneNumber',updateprofile, isSubmitted) && shouldShowMblErrors('phoneNumber',updateprofile) && (updateprofile.controls['phoneNumber'].value || isSubmitted)">
                      {{getErrorMessage('phoneNumber',updateprofile)}}</div>
                  </div>
                </div>
              </div>

              <div class="text-center row custom_padding">
                <button type="button" id="updateId"
                  class="updateprf_changebtn btn-new site-btn site-btn__primary site-btn--lg"
                  *ngIf="!isReadOnlyAttribute()" (click)="checkmobilereg('updateId',true,'update-profile')">
                  <span>{{'updateprofileComp.updateprofile9' | translate}}</span>
                </button>
                <p *ngIf="isReadOnlyAttribute()" class="Errormsg">{{'updateprofileComp.updateprofile10' | translate}}
                </p>
                <div *ngIf="message" class="successmsg align-center">{{'updateprofileComp.updateprofile11' | translate}}
                </div>
              </div>
              <div class="clearfix"></div>

            </form>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>